import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/auth";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { AppProvider } from "./context/appContext";
import { ChakraProvider } from "@chakra-ui/react";
import { LanguageProvider } from "./context/LanguageContext";
import ChatProvider from "./context/ChatProvider";
import { NotificationProvider } from "./context/NotificationContext";

const clientId =
  "410746866347-kd8go7ukk7lcgs8kc89adu0ish5r60gk.apps.googleusercontent.com";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <LanguageProvider>
        <ChakraProvider>
          <GoogleOAuthProvider clientId={clientId}>
            <AuthProvider>
              <AppProvider>
                <ChatProvider>
                  <NotificationProvider>
                    <App />
                  </NotificationProvider>
                </ChatProvider>
              </AppProvider>
            </AuthProvider>
          </GoogleOAuthProvider>
        </ChakraProvider>
      </LanguageProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('✅ Service Worker registered successfully:', registration.scope);
        
        // Check for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                console.log('🔄 New service worker available. Refresh to update.');
              }
            });
          }
        });
      })
      .catch((error) => {
        console.warn('⚠️ Service Worker registration failed:', error);
        // Don't block app if service worker fails - PWA can still work
      });
  });
}
